import { create } from "../../../../../common/utils/zustand_state_manager";
import { SetFunction, SetFunctionImpl } from "../../../../../common/utils/filters_utils";

type State = {
  idCentroCusto: number[];
  idCliente: number[];
  nomeProjeto: string;
  contato: string;
};

type Actions = {
  setNomeProjeto: SetFunction<string>;
  setContato: SetFunction<string>;
  setIdCentroCusto: SetFunction<number[]>;
  setIdCliente: SetFunction<number[]>;
};

export const initialProjetosListaFiltersState: State = {
  idCentroCusto: [],
  idCliente: [],
  nomeProjeto: "",
  contato: "",
};

export const useProjetosListaFilters = create<State & Actions>((set) => ({
  ...initialProjetosListaFiltersState,
  setNomeProjeto: (vfn) => SetFunctionImpl(set, 'nomeProjeto', vfn),
  setContato: (vfn) => SetFunctionImpl(set, 'contato', vfn),
  setIdCentroCusto: (vfn) => SetFunctionImpl(set, 'idCentroCusto', vfn),
  setIdCliente: (vfn) => SetFunctionImpl(set, 'idCliente', vfn),
}));
